import theme from 'theme'
import { Typography } from '@material-ui/core'
import helpers from 'helpers'

const valueLabel = (amount, status, classes) => {
  switch (status) {
    case 'paid':
      return (
        <Typography
          variant="h5"
          style={{
            color: theme.palette.success,
            fontWeight: 'bold',
          }}
        >
          +{helpers.formatters.floatToMoney(amount, false)} R$
        </Typography>
      )
    default:
      return (
        <Typography
          variant="h5"
          style={{
            fontWeight: 'bold',
          }}
        >
          {helpers.formatters.floatToMoney(amount, false)} R$
        </Typography>
      )
  }
}

export default valueLabel
